<script setup lang="ts">
const { t } = useI18n();
useSeoMeta({
  description: () => t("seo.welcome.description"),
});
useAnalyticsPageTitle(() => t("home.title"));
</script>

<template>
  <div>
    <WebSectionHero />

    <div id="content">
      <WebSectionFeatures />

      <WebSectionAppCTA />

      <WebSectionAbout />

      <div class="flex flex-col gap-y-16 md:gap-y-20 pt-10">
        <WebSectionNews />
      </div>

      <WebSectionPartners />
    </div>
  </div>
</template>
